import { useQuery } from "@tanstack/react-query";
import AuthService from "../services/auth.service";

export function useUser() {
  const { isLoading, data: user } = useQuery({
    queryKey: ["user"],
    queryFn: AuthService.getCurrentUser,
  });

  return {
    isLoading,
    user,
    isAdminAuthenticated: user?.role === "admin",
    isUserAuthenticated: user?.role === "user",
    isViewerAuthenticated: user?.role === "viewer",
    // Read-only access to the bot-operations pages. Mirrors the backend
    // `canViewBots` middleware — keep the two in sync.
    canViewBots: user?.role === "admin" || user?.role === "viewer",
  };
}
